export const dextPolicyObject = {
  "1M": "1 Μήνα Πριν και Μετά τη Λήξη",
  "3M": "Ο Προμηθευτής Δέχεται μόνο Ληξιπρόθεσμα 3Μ",
  "4M": "Ο Προμηθευτής Δέχεται μόνο Ληξιπρόθεσμα 4Μ",
  "6M": "Ο Προμηθευτής Δέχεται μόνο Ληξιπρόθεσμα 6Μ",
  "6M/EXP": "Ο Προμηθευτής Δέχεται Ληγμένα & Ληξιπρόθεσμα 6M",
  ALL: "Ο Προμηθευτής Δέχεται Όλες τις Επιστροφές",
  EXP: "Ο Προμηθευτής Δέχεται μόνο Ληγμένα",
  NONE: "Ο Προμηθευτής ΔΕΝ Δέχεται Επιστροφές",
  SPECIAL: "Ειδική Συμφωνία",
  "SPECIAL-75€": "Special agreement - 75€ per year",
};
